import React from 'react';

import { HStack } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import Picture from 'components/picture';
import { IImageFragment } from 'generated/sanity-graphql';

const Container = HStack.withConfig({
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: '3.5',
  paddingBottom: '3',
});

const Icon = Picture.withConfig({
  height: '7',
  width: '7',
  marginBottom: '1',
  marginRight: '2',
});

interface IEndOfOffersProps {
  image: IImageFragment | null;
  message: string;
}

export const EndOfOffers: React.FC<React.PropsWithChildren<IEndOfOffersProps>> = ({
  image,
  message,
}) => (
  <Container>
    {image && <Icon image={image} alt={message} objectFitContain />}
    <Typography variant="copyOne">{message}</Typography>
  </Container>
);
